import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import axiosPublic from "../../api/axiosConfig";
import axiosInstance from "../../api/axiosInstance";

const DJModal = ({ isOpen, onClose, djId, onStatusChange = null }) => {
  const [places, setPlaces] = useState([]);
  const [placeId, setPlaceId] = useState(null);
  const [price, setPrice] = useState(50);
  const [error, setError] = useState("");

  useEffect(() => {
    if (isOpen) {
      fetchPlaces();
    }
  }, [isOpen]);

  const fetchPlaces = async () => {
    try {
      const response = await axiosPublic.get("/place/available");

      setPlaces(response.data);
    } catch (err) {
      setError("Failed to load available places");
    }
  };

  const handleGoOnline = async () => {
    if (placeId == null) {
      setError("You must choose location");
      return;
    }

    if (price < 50) {
      setError("Price must be at least 50 PLN.");
      return;
    }

    try {
      const token = localStorage.getItem("token");
      await axiosInstance.patch(
        `/dj/${djId}/status-update`,
        { placeId, currentPrice: price, online: true },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      if (onStatusChange != null) {
        onStatusChange();
      }

      onClose();
    } catch (err) {
      console.error(err);
      setError("Error when updating status. Try again.");
    }
  };

  const handleGoOffline = async () => {
    try {
      const token = localStorage.getItem("token");
      await axiosInstance.patch(
        `/dj/${djId}/status-update`,
        { online: false },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      onClose();
    } catch (err) {
      setError("Error when trying go offline. Try again.");
    }
  };

  return (
    isOpen && (
      <div className="fixed top-0 left-0 w-full h-full z-50 bg-black bg-opacity-50 flex items-center justify-center px-4">
        <div className="bg-notificationList rounded-xl shadow-lg w-full max-w-md p-6 relative">
          <button
            className="absolute right-4 text-textMuted hover:text-white transition"
            onClick={onClose}
          >
            <X size={24} />
          </button>
          <h2 className="text-xl font-bold mb-4">Select location and price</h2>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2 text-textMuted">
              Location:
            </label>
            <select
              className="w-full p-2 rounded-xl outline outline-1 outline-secondary bg-notificationList text-textMain focus:outline-none focus:ring-1 focus:ring-accent appearance-none"
              value={placeId || "none"}
              onChange={(e) =>
                setPlaceId(
                  e.target.value === "none" ? null : Number(e.target.value),
                )
              }
            >
              <option value="none" disabled>
                Choose location
              </option>
              {places.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.name}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2 text-textMuted">
              Price (PLN):
            </label>
            <input
              type="text"
              className="w-full p-2 rounded-xl outline outline-1 outline-secondary bg-notificationList text-textMain focus:outline-none focus:ring-1 focus:ring-accent appearance-none"
              value={price}
              onChange={(e) => {
                let value = e.target.value.replace(/^0+/, "");
                value = value.replace(/[^0-9]/g, "");
                setPrice(value ? Number(value) : "");
              }}
              min={50}
            />
          </div>
          {error && <p className="text-red-500 text-sm mb-2">{error}</p>}
          <div className="flex justify-between">
            <button
              className="outline outline-1 outline-secondary px-4 py-2 rounded-lg text-white hover:bg-secondary"
              onClick={handleGoOffline}
            >
              Go offline
            </button>
            <button
              className="px-4 py-2 rounded-lg font-medium transition bg-accent hover:bg-opacity-80 text-black"
              onClick={handleGoOnline}
            >
              Go online
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default DJModal;
